import { styled } from '@linaria/react';
const typeIconClass = "t2162oh";
const EmptyStateAnnouncer = /*#__PURE__*/styled('div')({
  name: "EmptyStateAnnouncer",
  class: "eil7jdc",
  propsAsIs: false
});

/* limit description to 2 lines */
const lineLimitClass = "l429gum";
const ChildrenWrapper = /*#__PURE__*/styled('div')({
  name: "ChildrenWrapper",
  class: "c1hikxa4",
  propsAsIs: false
});
const StyledAnnouncer = /*#__PURE__*/styled('div')({
  name: "StyledAnnouncer",
  class: "sn3ubvc",
  propsAsIs: false
});
const ExpandButton = /*#__PURE__*/styled('button')({
  name: "ExpandButton",
  class: "e1rhc1w9",
  propsAsIs: false
});
const ActionButton = /*#__PURE__*/styled('button')({
  name: "ActionButton",
  class: "a10rj06c",
  propsAsIs: false
});
const CloseButton = /*#__PURE__*/styled('button')({
  name: "CloseButton",
  class: "c19650ud",
  propsAsIs: false
});
export { typeIconClass, EmptyStateAnnouncer, StyledAnnouncer, lineLimitClass, ExpandButton, ActionButton, CloseButton, ChildrenWrapper };

require("./Announcer.styles.linaria.module.css!=!../../../../../@linaria+webpack5-loader@4.1.17_webpack@5.83.1/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Announcer.styles.js");